import styled from 'styled-components'

import PhotoLazy from 'src/comps/PhotoLazy'
import { updatedMedia, maxWidthContent } from 'client/styles'

export const PhotosOverviewBase = styled.div``

export const StyledPhoto = styled(PhotoLazy)`
  cursor: pointer;
  min-height: 190px;
  ${updatedMedia.tablet} {
    min-height: 460px;
  }
  ${updatedMedia.desktop} {
    width: calc(50% - 20px);
    min-height: 300px;
  }
  img {
    border-radius: 8px;
    width: 100%;
    height: auto;
  }
`

export const Container = styled.div`
  max-width: ${maxWidthContent};
  margin-inline: auto;
  margin-block: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-block: 0 20px;
  padding-inline: 20px;
  ${updatedMedia.tablet} {
    padding-block: 0 20px;
    padding-inline: 40px;
    gap: 40px;
  }
`
